import type { Cart } from '../types/carts';
import { IProduct } from '../types/Product';

/**
 * Whether the cart qualifies for free shipping on product grounds alone, regardless of its total.
 *
 * The policy lives in web and arrives on each product as `shipsFree` over `GET /products`; this only
 * asks which of the fetched products carry the flag. Nothing here decides *which* products ship
 * free — adding another one is a web-side config change with no storefront release.
 *
 * Kept out of `lib/cart.ts` because that module reaches `lib/product` → `lib/util` → `uuid`, which
 * Jest cannot transform; as a leaf this stays unit-testable without mocking that chain.
 */
export function cartContainsFreeShippingProduct(cart: Cart, products: IProduct[]): boolean {
  const freeShippingSkus = new Set(
    products
      .filter((product) => product.shipsFree === true)
      .flatMap((product) => ('sku' in product ? [product.sku] : [])),
  );

  return Object.values(cart.cartItems).some((cartItem) => freeShippingSkus.has(cartItem.lineItem.sku));
}
